import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo5 } from "../../../routes/Module5";
import { modulo6 } from "../../../routes/Module6";
import Imagen1 from "../../../images/modulo5/ordenar1.png";
import Imagen2 from "../../../images/modulo5/ordenar2.png";
import Imagen3 from "../../../images/modulo5/ordenar3.png";
import Imagen4 from "../../../images/modulo5/ordenar4.png";
import Imagen5 from "../../../images/modulo5/ordenar5.png";
import Imagen6 from "../../../images/modulo5/ordenar6.png";
import Imagen7 from "../../../images/modulo5/ordenar7.png";
import Imagen8 from "../../../images/modulo5/ordenar8.png";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo5/Actividad 9.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo5.content[0];
  const infoAct = modulo5.content[0].activities[8];
  const crumbs = [
    {
      title: modulo5.title,
      url: "/" + modulo5.url,
    },
    {
      title:
        modulo5.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo5.content[0].activities[7].name}`,
    linkPrev: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[7].path}`,
  };
  const metadata = {
    color: modulo5.color,
    title: `${modulo5.title} - ${infoAct.name}`,
    name: modulo5.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo5.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul className="mb-5">
        <li>
          A continuación se muestra una breve historia del DNI. Lee y observa
          las ilustraciones.
        </li>
        <li>
          Comenta qué diferencias encuentras entre los documentos que se
          muestran.
        </li>
      </ul>

      <div className="row align-items-center mb-4 ms-md-3 ms-0">
        <div className="col-lg-4 col-md-6 col-12 text-center">
          <img src={Imagen1} alt="Comic" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-12">
          <span>
            En el año 1931, se crea la Libreta Electoral. En esa época, la
            mayoría de edad se alcanzaba a los 21 años.
          </span>
        </div>
      </div>
      <div className="row align-items-center mb-4 ms-md-3 ms-0">
        <div className="col-lg-4 col-md-6 col-12 text-center">
          <img src={Imagen7} alt="Comic" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-12">
          <span>
            En 1946, se creó la Libreta Electoral Municipal. Tenía cuatro hojas.
          </span>
        </div>
      </div>
      <div className="row align-items-center mb-4 ms-md-3 ms-0">
        <div className="col-lg-4 col-md-6 col-12 text-center">
          <img src={Imagen4} alt="Comic" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-12">
          <span>
            La Libreta Electoral de siete dígitos apareció en el año 1963.
          </span>
        </div>
      </div>
      <div className="row align-items-center mb-4 ms-md-3 ms-0">
        <div className="col-lg-4 col-md-6 col-12 text-center">
          <img src={Imagen2} alt="Comic" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-12">
          <span>
            En 1984, la Libreta Electoral pasó a tener ocho dígitos. En este
            año, la mayoría de edad se alcanzaba a los 18 años.
          </span>
        </div>
      </div>
      <div className="row align-items-center mb-4 ms-md-3 ms-0">
        <div className="col-lg-4 col-md-6 col-12 text-center">
          <img src={Imagen3} alt="Comic" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-12">
          <span>El primer DNI apareció en el año 1997.</span>
        </div>
      </div>
      <div className="row align-items-center mb-4 ms-md-3 ms-0">
        <div className="col-lg-4 col-md-6 col-12 text-center">
          <img src={Imagen8} alt="Comic" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-12">
          <span>
            La versión actual del DNI que todos conocemos existe desde el año
            2005.
          </span>
        </div>
      </div>
      <div className="row align-items-center mb-4 ms-md-3 ms-0">
        <div className="col-lg-4 col-md-6 col-12 text-center">
          <img src={Imagen5} alt="Comic" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-12">
          <span>
            También en el año 2005 se creó el DNI para menores de edad.
          </span>
        </div>
      </div>
      <div className="row align-items-center mb-4 ms-md-3 ms-0">
        <div className="col-lg-4 col-md-6 col-12 text-center">
          <img src={Imagen6} alt="Comic" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-12">
          <span>
            El DNI electrónico, que es el más reciente, existe desde el año
            2013.
          </span>
        </div>
      </div>

      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo6.url}>
          <button className={`btn btn-${modulo5.color} me-2`}>
            {modulo6.title + " >"}
          </button>
        </a>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Lean los datos. Pregunte cómo pueden saber el
          orden correcto en que van los datos (la respuesta es por los años).
          Ayude a completar la actividad.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
